<template>
    <div
        :class="$style.details"
        data-interface-section="game-details"
    >
        <Breadcrumbs
            v-if="!appStore.isAppEnv"
            :breadcrumbs="props.breadcrumbs"
        />
        <Typography
            is="h1"
            id="game-title"
            type="header"
            size="m"
            :responsive="false"
        >
            {{ props.game.title }}
        </Typography>
        <MetaInformation
            :game="props.game"
            :categoriesInfo="props.categoriesInfo"
        />
        <div
            v-if="gameTags.length"
            :class="$style.tags"
        >
            <component
                :is="index > 5 ? SeoOnly : 'div'"
                v-for="(tag, index) in gameTags"
                :key="tag.id"
            >
                <TagButton
                    :to="tag.href"
                    :name="tag.title"
                    :count="tag.totalCount"
                />
            </component>
        </div>
        <Actions />
        <SeoBlock :game="props.game" />
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { RouteLocationRaw } from 'vue-router'

import Breadcrumbs from '@/components_new/Breadcrumbs.vue'
import SeoOnly from '@/components_new/SeoOnly.vue'
import Typography from '@/components_new/Typography.vue'
import { getSubCategories } from '@/pages/Games/utils'
import { useAppStore } from '@/store/app-store'
import type { APIGameType, GameCategoriesInfoType } from '@/types'

import Actions from './Actions.vue'
import MetaInformation from './MetaInformation.vue'
import SeoBlock from './SeoBlock.vue'
import TagButton from './TagButton.vue'

const props = defineProps<{
    game: APIGameType
    categoriesInfo: GameCategoriesInfoType
    breadcrumbs: { href: string | RouteLocationRaw; title: string }[]
}>()

const appStore = useAppStore()

const gameTags = computed(() => getSubCategories('tag', props.categoriesInfo))
</script>
<style module>
.details {
    border-radius: 16px;
    background: var(--carbon-300);
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.tags {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 8px 0;
}

.tags > *:not(:last-child) {
    margin-right: 6px;
}
</style>
